'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { SelectItemProps } from '@sola/ark-core/molecules/select/select.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { ArticleLimitEnum, ArticleSortByEnum, useArticleQueryParams, usePaginationQueryParams } from '../../utils/query-params.tsx';
const showNumArticlesValues: SelectItemProps[] = ArticleLimitEnum.options.map(limit => ({
  value: limit.toString()
}));
export const ArticleFilter = t0 => {
  const $ = _c(52);
  const {
    articleCount,
    limit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["articles", "skippy"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("articles:sort.featured");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      text: t2,
      value: ArticleSortByEnum.enum.promotedContent
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("articles:sort.newest");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      text: t4,
      value: ArticleSortByEnum.enum.desc
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("articles:sort.oldest");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      text: t6,
      value: ArticleSortByEnum.enum.asc
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t8 = [t3, t5, t7];
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const sortByItems = t8;
  let t9;
  if ($[17] !== limit) {
    t9 = {
      perPage: limit
    };
    $[17] = limit;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const {
    articleFilters,
    setArticleFilters
  } = useArticleQueryParams(t9);
  const {
    setCurrentPage
  } = usePaginationQueryParams();
  let t10;
  if ($[19] !== setArticleFilters || $[20] !== setCurrentPage) {
    t10 = e => {
      setArticleFilters(prev => ({
        ...prev,
        limit: Number(e.target.value)
      }));
      setCurrentPage(0);
    };
    $[19] = setArticleFilters;
    $[20] = setCurrentPage;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handlePerPageChange = t10;
  let t11;
  if ($[22] !== setArticleFilters) {
    t11 = e_0 => {
      setArticleFilters(prev_0 => ({
        ...prev_0,
        sortby: e_0.target.value as ArticleSortByEnum
      }));
    };
    $[22] = setArticleFilters;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const handleSortByChange = t11;
  let t12;
  if ($[24] !== articleCount || $[25] !== t) {
    t12 = articleCount === undefined ? undefined : t("articles:resultWithCount", {
      count: articleCount
    });
    $[24] = articleCount;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <div className="body-md md:align-center">{t12}</div>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== handleSortByChange) {
    t14 = e_1 => handleSortByChange(e_1);
    $[29] = handleSortByChange;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = articleFilters.sortby;
  let t16;
  if ($[31] !== t) {
    t16 = t("articles:sortArticlesBy");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== articleFilters.sortby || $[34] !== sortByItems || $[35] !== t14 || $[36] !== t16) {
    t17 = <Select onChange={t14} value={t15} name="sort" items={sortByItems} aria-label={t16} />;
    $[33] = articleFilters.sortby;
    $[34] = sortByItems;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== handlePerPageChange) {
    t18 = e_2 => handlePerPageChange(e_2);
    $[38] = handlePerPageChange;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = articleFilters.limit;
  let t20;
  if ($[40] !== t) {
    t20 = t("articles:numberOfArticles");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== articleFilters.limit || $[43] !== t18 || $[44] !== t20) {
    t21 = <Select onChange={t18} value={t19} name="visibleArticles" items={showNumArticlesValues} aria-label={t20} />;
    $[42] = articleFilters.limit;
    $[43] = t18;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t17 || $[47] !== t21) {
    t22 = <div className="flex align-end md:justify-end md:align-center gap-comfy-sm">{t17}{t21}</div>;
    $[46] = t17;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t13 || $[50] !== t22) {
    t23 = <div className="ArticleFilter"><div className="ArticleFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">{t13}{t22}</div></div>;
    $[49] = t13;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};